import { useNavigate } from 'react-router-dom'

import Groups from './Groups'
import Color from './Color'

import { FiArrowLeft } from 'react-icons/fi'

const Settings = () => {
  const navigate = useNavigate()

  const back = () => {
    navigate( -1 )
  }

  return <section className="scroll one hs">

    <div className="bar">
      <button
        onClick={ back }
      >
        <FiArrowLeft />
      </button>

      <h1>settings</h1>
    </div>

    <Color />

    <Groups />

  </section>
}

export default Settings
